import React, { useState, useEffect } from 'react';
import { ApplicationService } from './../../../service/application.service'

const CompanyRequestItem = (params) => {
    const [applications, setApplications] = useState([]);
    const applicationService = new ApplicationService();

    useEffect(() => {
        const fetchData = async () => {
            const rsApp = await applicationService.getApplications();
            setApplications(rsApp.data);
        }

        fetchData()
            .catch(console.error);
    }, []);

    const getApplicationName = (id) => {
        let appName = "";

        if (applications.length > 0) {
            let app = applications.filter((x) => {
                return (x.id === id);
            });

            if (app !== undefined) {
                appName = app.name;
            }
        }
        return appName;
    }

    return (
        <div className="card" style={{ maxWidth: "750px" }}>
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> Company Request
            </h5>
            <div className="card-body">
                <div className="ag-theme-alpine">
                    <div style={{ backgroundColor: 'white', marginBottom: "15px" }}>
                        <div className="row" style={{ marginBottom: "10px" }}>
                            <div className="col-md-6">
                                <b>Company Name:</b> {params.data.name}
                            </div>
                            <div className="col-md-6" style={{ marginBottom: "10px" }}>
                                <b>Allowed Domain:</b> {params.data.allowedDomain}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6" style={{ marginBottom: "10px" }}>
                                <b>Requestor Name:</b> {params.data.requestorName}
                            </div>
                            <div className="col-md-6">
                                <b>Requestor Email:</b> {params.data.requestorEmail}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <b>Created Date:</b> {params.data.createdDate}
                            </div>
                            <div className="col-md-6">
                                <b>Modified Date:</b> {params.data.modifiedDate}
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div className="card-footer text-muted">
                <div style={{ textAlign: "center" }}>
                    <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default CompanyRequestItem;